import React from 'react';
import Marketplace from '@/pages/Marketplace';

const MarketplaceHome = () => {
  return (
    <div className="space-y-6" data-testid="marketplace-home-page">
      <div className="panel-header">
        <div>
          <div className="panel-title">Marketplace</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mt-2">CNC Maker Marketplace</h1>
          <p className="text-sm md:text-base text-[var(--text-secondary)] mt-2 max-w-2xl">
            Browse machines, tooling, materials, digital files, and services from other CNC makers.
          </p>
        </div>
      </div>
      <Marketplace />
    </div>
  );
};

export default MarketplaceHome;
